import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButton],
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {

  readonly dialogRef = inject(MatDialogRef<ConfirmationDialogComponent>);

  readonly data = inject(MAT_DIALOG_DATA);

  title = signal<string | null>(null);

  message = signal<string | null>(null);

  confirmText = signal<string>('Confirm');


  constructor() {
    const { title, message, confirmText } = this.data;

    this.title.set(title);
    this.message.set(message);

    if (confirmText) {
      this.confirmText.set(confirmText);
    }
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}


export interface ConfirmationDialogPayload {
  title: string;
  message: string;
  confirmText?: string;
}